import React from "react";

const ExclamationSmall = ({ width, fill }) => {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4.5C8 6.70914 6.20914 8.5 4 8.5C1.79086 8.5 0 6.70914 0 4.5C0 2.29086 1.79086 0.5 4 0.5C6.20914 0.5 8 2.29086 8 4.5ZM4.44455 6.7222H3.55566V5.83333H4.44455V6.7222ZM3.55566 5.389H4.44455V2.72233H3.55566V5.389Z"
        fill="#F5821E"
      />
    </svg>
  );
};

ExclamationSmall.defaultProps = {
  width: 13,
  fill: "black",
};

export default ExclamationSmall;
